import React, { useState } from "react";
import { Search } from "lucide-react";
import OpsTopBar from "../../components/ops/OpsTopBar";
import QueueRow from "../../components/ops/QueueRow";
import { useOpsRole } from "../../context/OpsRoleContext";
import useApi from "../../hooks/useApi";

const SCOPES = [
  ["all", "All"], ["today", "Today"], ["overdue", "Overdue"], ["upcoming", "Upcoming"],
  ["high", "High priority"], ["completed", "Completed"], ["attention", "Requires attention"],
];
const PLATFORMS = ["", "Instagram", "Facebook", "LinkedIn"];
const FORMATS = ["", "Story", "Feed", "Reel"];

function Select({ value, onChange, options, testid, placeholder }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
      className="rounded-full border bg-white px-3.5 py-2 text-sm text-ink focus-ring" style={{ borderColor: "#E7E8E4" }}>
      <option value="">{placeholder}</option>
      {options.filter(Boolean).map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}

export default function OpsQueue() {
  const { role } = useOpsRole();
  const [scope, setScope] = useState("all");
  const [platform, setPlatform] = useState("");
  const [fmt, setFmt] = useState("");
  const [search, setSearch] = useState("");

  const params = new URLSearchParams({ role, scope });
  if (platform) params.set("platform", platform);
  if (fmt) params.set("fmt", fmt);
  if (search) params.set("search", search);
  const path = `/ops/queue?${params.toString()}`;
  const { data } = useApi(path, [path]);
  const tasks = data?.tasks || [];

  return (
    <>
      <OpsTopBar title="Queue" subtitle={`${tasks.length} actions`} />
      <div className="p-6 sm:p-8 max-w-[1400px] space-y-5">
        {/* Search */}
        <div className="relative max-w-xl">
          <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-ink-3" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} data-testid="ops-queue-search"
            placeholder="Search branch, agency, property, postcode, account…"
            className="w-full rounded-full border bg-white pl-10 pr-4 py-2.5 text-sm text-ink focus-ring" style={{ borderColor: "#E7E8E4" }} />
        </div>

        {/* Scope tabs */}
        <div className="flex flex-wrap gap-2" data-testid="ops-queue-scopes">
          {SCOPES.map(([k, l]) => (
            <button key={k} onClick={() => setScope(k)} data-testid={`scope-${k}`}
              className="rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors border"
              style={scope === k ? { background: "var(--grad-ink)", color: "#fff", borderColor: "transparent" } : { color: "#6B6E62", borderColor: "#E7E8E4", background: "#fff" }}>
              {l}
            </button>
          ))}
        </div>

        {/* Filters */}
        <div className="flex flex-wrap gap-2.5">
          <Select value={platform} onChange={setPlatform} options={PLATFORMS} testid="filter-platform" placeholder="All platforms" />
          <Select value={fmt} onChange={setFmt} options={FORMATS} testid="filter-format" placeholder="All formats" />
        </div>

        {/* Results */}
        <div className="card overflow-hidden divide-y" style={{ borderColor: "#E7E8E4" }} data-testid="ops-queue-list">
          {tasks.length === 0 && <div className="p-8 text-center text-ink-2 text-sm">No actions match these filters.</div>}
          {tasks.map((t) => <QueueRow key={t.id} task={t} />)}
        </div>
      </div>
    </>
  );
}
